export default __webpack_public_path__ + "static/media/estrela.bca85165.svg";